import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FiArrowLeft } from 'react-icons/fi';
import BaselineForm from '../../components/Baselines/BaselineForm';
import baselineService from '../../services/baselineService';

const BaselineCreate = () => {
  const navigate = useNavigate();

  const handleSubmit = async (formData) => {
    try {
      await baselineService.createBaseline(formData);
      alert('Baseline created successfully!');
      navigate('/app/baselines');
    } catch (error) {
      alert(error.message || 'Failed to create baseline');
      throw error;
    }
  };

  const handleCancel = () => {
    navigate('/app/baselines');
  };

  return (
    <div className="baseline-create-page" style={{ padding: '2rem', maxWidth: '1400px', margin: '0 auto' }}>
      <div className="page-header" style={{ marginBottom: '2rem' }}>
        <button 
          onClick={handleCancel}
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            background: 'none',
            border: 'none',
            color: '#007bff',
            cursor: 'pointer',
            fontSize: '1rem',
            marginBottom: '1rem'
          }}
        >
          <FiArrowLeft /> Back to Baselines
        </button>
        <h1 style={{ margin: 0, fontSize: '2rem', fontWeight: '700' }}>Create New Baseline</h1>
        <p style={{ margin: '0.5rem 0 0 0', color: '#6c757d' }}>
          Define a new baseline for project scope, schedule, and cost tracking
        </p>
      </div>

      <BaselineForm onSubmit={handleSubmit} onCancel={handleCancel} />
    </div>
  );
};

export default BaselineCreate;


